import { render, staticRenderFns } from "./EditContactSettings.vue?vue&type=template&id=477645ba&"
import script from "./EditContactSettings.vue?vue&type=script&lang=ts&"
export * from "./EditContactSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports